module.exports = __webpack_public_path__ + "static/media/Logo_Dark.0588c629.png";